import { Anchor, Text } from '@mantine/core';
import type { AutomationLog } from 'modules/Settings/Automation/api';

type ResourceAnchorProps = {
  log: AutomationLog;
};

export const ResourceAnchor = ({ log }: ResourceAnchorProps) => {
  const url = log.model === 'debtor' ? `/clients/${log.resourceId}` : `/invoices/${log.resourceId}`;

  return (
    <Anchor href={url} target="_blank">
      <Text c="purple.6" fw={600}>
        {log.identifier}
      </Text>
    </Anchor>
  );
};
